module["exports"] = [
  "#{Name.first_name}#{street_suffix}",
  "#{Name.last_name}#{street_suffix}"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/nl/address/street_name.js
// module id = 1415
// module chunks = 0